<script>
import axios from '@/utils/axios';
import { allUsers } from '@/utils/user';
// import { countries, states, pincodeWiseAddress } from '@/utils/admin';
import { pincodeWiseAddress } from '@/utils/admin';
import { Modal } from 'bootstrap';
import { useLeadMetaStore } from '@/stores/useLeadMetaStore';
import { useCountryStore } from '@/stores/useCountryStore';
import { useCurrenciesStore } from '@/stores/useCurrenciesStore'
import { useStatesStore } from '@/stores/useStatesStore'

export default {
inject: ['setLoading'],  
  data() {
    return {
     ids: [], 
     errors: {}, 
     id: '',
     user: '',
     lead_stage: '',
     lead_source: '',
     lead_user_id: '',
     name: '',
     email: '',
     mobile: '',
     alt_mobile: '',
     gst_no: '',
     designation: '',
     company_name: '',
     currency: '',
     address: '',
     address2: '',
     city: '',
     state: '',
     country: '',
     pincode: '',
     alt_mobile: '',
     countries: [],
     states: [],
     users: [],
     stages: [],
     sources: [],
     currencies: [],
     mass_delete: false,
     country: null,
     state: null,
    };
  },
  computed: {
  
  },
  mounted(){
  this.loadMeta();
  //  this.getUsers();
  //  this.getStages();
  //  this.getSources();
   this.getCurrencies();
  //  this.getCountries();
  },
  methods: {

async loadMeta() {
  const store = useLeadMetaStore()
  await store.loadAll()
  this.stages  = store.stages
  this.sources = store.sources
  this.users   = store.users
  if(!this.id){
    this.setDefaultLeadUser()
  }
},


openChildModal(modalId) {
  const el = document.getElementById(modalId);
  const modal = Modal.getOrCreateInstance(el); 
  modal.show();
},

onStageAdded() {
  const store = useLeadMetaStore()
  store.refresh()          // force refetch
    .then(() => {
      this.stages  = store.stages
      this.sources = store.sources
      this.users   = store.users
    })
},


onSourceAdded() {
  const store = useLeadMetaStore()
  store.refresh()          // force refetch
    .then(() => {
      this.stages  = store.stages
      this.sources = store.sources
      this.users   = store.users
    })
},
   add(){
    this.resetForm();
    this.getCountries();
   },
   
  //  async getCurrencies(){
  //   this.setLoading(true);
  //   try{
  //    const response = await axios.get('currencies');
  //    this.currencies = response.data.data;
  //    this.currency = this.currencies.find(c => c.id === this.clientSetting?.currency_id);
  //   }catch(error){
  //    console.log(error.message);
  //   }finally{
  //    this.setLoading(false);
  //   }
  //  },

   async getCurrencies(){
  const store = useCurrenciesStore()
  this.currencies = await store.loadCurrencies()
  this.currency = this.currencies.find(c => c.id === this.clientSetting?.currency_id)
},

  //  
  //   async getCountries(){
  //  this.setLoading(true);
  //  try{
  //   const response = await countries();
  //   this.countries = response.data.data;
  //   if(!this.id){
  //    //if creating new customer, then set default country 
  //    this.country = this.countries.find(c => c.name === this.clientAdmin?.company?.country);
  //   }
  //   this.getStates(this.country?.id);
  //  }catch(error){
  //   this.$swalToast(error.message, 'error');
  //  }finally{
  //   this.setLoading(false);
  //  } 
  // },
  async getCountries(){
  const store = useCountryStore()
  this.countries = await store.loadCountries()
  if(!this.id){
    this.country = this.countries.find(c => c.name === this.clientAdmin?.company?.country)
  }
  this.getStates(this.country?.id)
},

  onCountrySelect(country){
   this.getStates(country?.id);
  },

  // async getStates(country_id){
  //  this.state = null;
  //  this.states = [];
  //   if(country_id){
  //   try{ 
  //    const response = await states(country_id);
  //    this.states = response.data.data;
  //    //if creating new customer, then set default country 
  //    this.state = this.states.find(s => s.name === this.clientAdmin?.company?.state);
  //   }catch(error){
  //    this.$swalToast(error.message, 'error');
  //   }
  //  }  
  // },

  async getStates(country_id){
  this.state = null
  this.states = []
  if(country_id){
    const store = useStatesStore()
    this.states = await store.loadStates(country_id)
    this.state = this.states.find(s => s.name === this.clientAdmin?.company?.state)
  }
},
  

   setDefaultLeadUser(){
    const meInUsers = this.users.find(u => u.id === this.auth?.id);
    if(meInUsers){
     this.user = meInUsers;
    }
   },
   
  //  async getUsers(){
  //   try{
  //    const response = await allUsers();
  //    this.users = response.data.data;
  //    if(!this.id){
  //     this.setDefaultLeadUser(); 
  //    }
  //   }catch(error){
  //    console.log(error.message);
  //   } 
  //  },
   
  editLead(lead) {
    this.errors = {};
    this.id = lead.id;
    this.lead_user_id = lead.user_id;
    this.user = this.users.find(u => u.id === lead.user_id);
    this.lead_stage = this.stages.find(stage => stage.id === lead.lead_stage_id);
    this.lead_source = this.sources.find(source => source.id === lead.lead_source_id);
    this.currency = this.currencies.find(c => c.id === lead.currency_id);
    this.name = lead.name;
    this.email = lead.email;
    this.mobile = lead.mobile;
    this.gst_no = lead.gst_no;
    this.alt_mobile = lead.alt_mobile;
    this.designation = lead.designation;
    this.company_name = lead.company_name;
    this.address = lead.address;
    this.address2 = lead.address2;
    this.city = lead.city;
    this.state = lead.state;
    this.country = lead.country;
    this.pincode = lead.pincode;
   },  

  //  async getStages(){
  //  this.setLoading(true);
  //  try{
  //   const response = await axios.get('/lead-stages');
  //   this.stages = response.data.data;
  //  }catch(error){
  //   this.$swalToast(error.message, 'error');
  //  }finally{
  //   this.setLoading(false);
  //  }
  // },

  // async getSources(){
  //  this.setLoading(true);
  //  try{
  //   const response = await axios.get('/lead-sources');
  //   this.sources = response.data.data;
  //  }catch(error){
  //   this.$swalToast(error.message, 'error');
  //  }finally{
  //   this.setLoading(false);
  //  }
  // },

   async submitForm(){
    this.errors = {};
    this.setLoading(true); 

    try{
     
     const payload = {
      id: this.id, 
      user_id: this.user?.id ?? this.lead_user_id,
      lead_stage_id: this.lead_stage?.id,
      lead_source_id: this.lead_source?.id,
      name: this.name,
      email: this.email,
      mobile: this.mobile,
      gst_no: this.gst_no,
      alt_mobile: this.alt_mobile,
      designation: this.designation,
      company_name: this.company_name,
      address: this.address,
      address2: this.address2,
      city: this.city,
      state: this.state?.name,
      country: this.country?.name,
      pincode: this.pincode,
      currency_id: this.currency?.id
     }; 
     
     let response = [];
     if(this.id){
      //UPDATE
      response = await axios.put('/leads/update', payload);
     }else{
      //CREATE
      response = await axios.post('/leads/create', payload);
     }
     this.$swalToast(response.data.message);
     this.$emit('updated'); 
     this.$closeModal('lead_modal');
     this.resetForm();
    }catch(error){
     if(error.type == 'validation'){  
      this.errors = error.errors;
     }else{
      this.$swalToast(error.message, 'error');
     }
    }finally{
     this.setLoading(false); 
    }
   },

  async deleteLead(){
   this.errors = {};
   this.setLoading(true); 
   try{
    const response = await axios.delete('/leads/'+this.id+'/delete');
    this.$swalToast(response.data.message);
    this.$emit('updated');
    this.$closeModal('delete_modal');
   }catch(error){
    if(error.type == 'validation'){
     this.errors = error.errors;
    }else{
     this.$swalToast(error.message, 'error'); 
    }
   }finally{
    this.setLoading(false);
   }
  }, 

  async assignLead(){
   this.errors = {};
   this.setLoading(true);
   try{
    const response = await axios.patch(`/leads/${this.id}/assign`, {
     user_id: this.user_id
    });
    this.$swalToast(response.data.message);
    this.$emit('updated');
    this.$closeModal('assign_lead_modal');
   }catch(error){
    if(error.type == 'validation'){
     this.errors = error.errors;
    }else{
     this.$swalToast(error.message, 'error'); 
    }
   }finally{
    this.setLoading(false);
   }
  },

  bulkAction(ids){
   this.ids = ids;
   this.resetForm();
  },

  async submitBulkAction() {
   const result = await this.$confirm({});
   if(result.isConfirmed){
    this.setLoading(true); 
    try{
     const response = await axios.post('/leads/bulk-actions', {
      ids: this.ids,
      mass_delete: this.mass_delete,
      lead_stage_id: this.lead_stage?.id || '',
      lead_source_id: this.lead_source?.id || '',
      user_id: this.user?.id || '',
     });
     this.$swalToast(response.data.message);
     this.$emit('updated');
     this.$closeModal('bulk_action_lead');
    }catch(error){
     this.$swalToast(error.message, 'error');
    }finally{
     this.setLoading(false);
    }
   }
  },

 async convert(){
   this.errors = {};
   this.setLoading(true);
   try{
    const response = await axios.patch(`/leads/${this.id}/convert`, {
     company_name: this.company_name 
    }); 
    this.$swalToast(response.data.message);
    this.$emit('updated');
    this.$closeModal('lead_conversion_modal');
   }catch(error){
    if(error.type === 'validation'){
     this.errors = error.errors;
    }else{
     this.$swalToast(error.message, 'error');
    }
   }finally{
    this.setLoading(false);
   } 
  },

  checkPincode(){
   if(this.pincode.length < 6){
    this.errors.pincode = ["The pincode field must be 6 digits."];
   }else{
    delete this.errors.pincode;
    clearTimeout(this.pincodeTimeout);
    this.pincodeTimeout = setTimeout(() => {
     this.addressByPincode();
    }, 500);   
   }
  },

  async addressByPincode(){
   this.setLoading(true);
   try{
    const response = await pincodeWiseAddress(this.pincode);
    const data = response.data.data;
    const new_country = data?.country ? this.countries.find(c => c.name === data.country) : this.country;
    this.city = data?.city || this.city;
    if(new_country && new_country?.id !== this.country?.id){
     this.country = new_country;
     await this.getStates(new_country.id);
     this.state = data?.state ? this.states.find(s => s.name === data.state) : this.state;
    }else if(data?.state){
     this.state = this.states.find(s => s.name === data.state);
    }
   }catch(error){
    console.log('Pincode lookup failed:', error.message);
   }finally{
    this.setLoading(false);
   }
  },

  resetForm() {
   this.id = null;
   this.user_id = '';
   this.lead_stage = '';
   this.lead_source = '';
   this.name = '';
   this.email = '';
   this.mobile = '';
   this.gst_no = '';
   this.designation = '';
   this.company_name = '';
   this.address = '';
   this.address2 = '';
   this.city = '';
   this.state = '';
   this.country = '';
   this.pincode = '';
   this.errors = {};
   this.mass_delete = false;
  },
  
  validateEmail(){
  if(!this.email){
   return;
  }
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
   if(!emailPattern.test(this.email)){
    this.errors.email = ["Please fill full domain"];
   }else{
    delete this.errors.email;
   }
  }
  },
};
</script>

<style>
 hr{
  height: 2px;
  background-color: lightgrey;
 }
</style>

<template>
<!-- Add Leads -->
<div class="modal fade" id="lead_modal">
<div class="modal-dialog modal-dialog-centered modal-lg">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ id ? 'Edit' : 'Add'}} Lead</h4>
      <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
        <i class="ti ti-x"></i>
      </button>
    </div>
    <form @submit.prevent="submitForm">
      <div class="modal-body pb-0">
        <div class="row">

        <div class="col-md-4">
        <div class="mb-3">
        <label class="form-label">Name <span class="text-danger"> *</span></label>
        <input type="text" class="form-control" v-model="name" />
        <div v-if="errors.name" class="text-danger small mt-1">{{ errors.name[0] }}</div>
        </div>
        </div>

        <div class="col-md-4">
        <div class="mb-3">
        <label class="form-label">Mobile No <span class="text-danger"> *</span></label>
        <input type="text" class="form-control" v-model="mobile" />
        <div v-if="errors.mobile" class="text-danger small mt-1">{{ errors.mobile[0] }}</div>
        </div>
        </div>

        <div class="col-md-4">
        <div class="mb-3">
        <label class="form-label">Alt Contact No </label>
        <input type="text" class="form-control" v-model="alt_mobile" />
        <div v-if="errors.alt_mobile" class="text-danger small mt-1">{{ errors.alt_mobile[0] }}</div>
        </div>
        </div>

        <div class="col-md-4">
        <div class="mb-3">
        <label class="form-label">Email </label>
        <input type="text" class="form-control" v-model="email"  @blur="validateEmail" @input="validateEmail" />
        <div v-if="errors.email" class="text-danger small mt-1">{{ errors.email[0] }}</div>
        </div>
        </div>



        <!-- <div class="col-md-3">
        <div class="mb-3">
        <label class="form-label">Designation </label>
        <input type="text" class="form-control" v-model="designation" />
        <div v-if="errors.designation" class="text-danger small mt-1">{{ errors.designation[0] }}</div>
        </div>
        </div> -->

        <div class="col-md-4">
        <div class="mb-3">
        <label class="form-label">Organization Name </label>
        <input type="text" class="form-control" v-model="company_name" />
        <div v-if="errors.company_name" class="text-danger small mt-1">{{ errors.company_name[0] }}</div>
        </div>
        </div>

        <div class="col-md-4">
        <div class="mb-3">
        <label class="form-label">GST No </label>
        <input type="text" class="form-control" v-model="gst_no" />
        <div v-if="errors.gst_no" class="text-danger small mt-1">{{ errors.gst_no[0] }}</div>
        </div>
        </div>

        <div div class="col-md-6">
        <div class="mb-3">
        <label class="form-label">Address Line 1 </label>
        <input type="text" class="form-control" v-model="address" />
        <div v-if="errors.address" class="text-danger small mt-1">{{ errors.address[0] }}</div>
        </div>
        </div>

        <div class="col-md-6">
        <div class="mb-3">
        <label class="form-label">Address Line 2 </label>
        <input type="text" class="form-control" v-model="address2" />
        <div v-if="errors.address2" class="text-danger small mt-1">{{ errors.address2[0] }}</div>
        </div>
        </div>

        <div class="col-md-3">
        <div class="mb-3">
          <label class="form-label fw-semibold small mb-2">Pincode <span class="text-danger">*</span></label>
          <input type="text" class="form-control" v-model="pincode" maxlength="6" @keyup="checkPincode" />
          <small class="text-danger" v-if="errors.pincode">{{ errors.pincode[0] }}</small>
        </div>
        </div>

        <div class="col-md-3">
          <label class="form-label fw-semibold small mb-2">City <span class="text-danger">*</span></label>
          <input type="text" class="form-control" v-model="city" />
          <small class="text-danger" v-if="errors.city">{{ errors.city[0] }}</small>
        </div>
        <div class="col-md-3">
          <label class="form-label fw-semibold small mb-2">Country <span class="text-danger">*</span></label>
          <vue-select :options="countries" label="name" v-model="country" @update:modelValue="onCountrySelect" />
          <small class="text-danger" v-if="errors.country">{{ errors.country[0] }}</small>
        </div>
        <div class="col-md-3">
          <label class="form-label fw-semibold small mb-2">State <span class="text-danger">*</span></label>
          <vue-select :options="states" label="name" v-model="state" />
          <small class="text-danger" v-if="errors.state">{{ errors.state[0] }}</small>
        </div>

        <!-- <div class="col-md-4">
        <div class="mb-3">
        <label class="form-label">Currency </label>
        <vue-select :options="currencies" label="name" v-model="currency" />
        <div class="text-danger small mt-1" v-if="errors.currency_id">{{errors.currency_id[0]}}</div>
        </div>
        </div> -->

        <div class="col-md-12">
         <hr>
        </div>

        <div class="col-md-4">
        <div class="mb-3">
        <label class="form-label">Stage </label>
        <a href="javascript:void(0);" class="add-new text-primary float-end" 
          @click="openChildModal('stage_modal')">
          <i class="ti ti-plus text-primary me-1"></i>Add New
        </a>
        <vue-select :options="stages" label="name" v-model="lead_stage" placeholder="Select" />
        <div v-if="errors.lead_stage_id" class="text-danger small mt-1">{{ errors.lead_stage_id[0] }}</div>
        </div>
        <!-- <div style="min-height: 100px;"></div> -->
        </div>

        <div class="col-md-4">
        <div class="mb-3">
        <label class="form-label">Source </label>
        <a href="javascript:void(0);" class="add-new text-primary float-end" 
          @click="openChildModal('source_modal')">
          <i class="ti ti-plus text-primary me-1"></i>Add New
        </a>
        <vue-select :options="sources" label="name" v-model="lead_source" placeholder="Select" />
        <div v-if="errors.lead_source_id" class="text-danger small mt-1">{{ errors.lead_source_id[0] }}</div>
        </div>
        </div>

        <div class="col-md-4">
        <div class="mb-3">
        <label class="form-label">Assign To </label>
        <vue-select :options="users" label="name" v-model="user" placeholder="Select" />
        <div v-if="errors.user_id" class="text-danger small mt-1">{{ errors.user_id[0] }}</div>
        </div>
        </div>

        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
        <button type="submit" class="btn btn-primary">Save</button>
      </div>
    </form>
  </div>
</div>
</div>
<!-- /Add Leads -->

<!-- Assign Leads -->
<div class="modal fade" id="assign_lead_modal">
<div class="modal-dialog modal-dialog-centered modal-sm">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">Assign Lead</h4>
      <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
        <i class="ti ti-x"></i>
      </button>
    </div>
    <form @submit.prevent="assignLead">
      <div class="modal-body pb-0">
        <div class="row">

        <div class="col-md-12">
        <div class="mb-3">
        <label class="form-label">Assign To </label>
        <select class="form-select" v-model="user_id">
         <option v-for="row in users" :key="row.id" :value="row.id">{{ row.name }}</option> 
        </select>
        <div v-if="errors.user_id" class="text-danger small mt-1">{{ errors.user_id[0] }}</div>
        </div>
        </div>

        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
        <button type="submit" class="btn btn-primary">Assign</button>
      </div>
    </form>
  </div>
</div>
</div>
<!-- /Assign Leads -->

<!-- Delete Modal -->
<div class="modal fade" id="delete_modal">
<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-body text-center">
      <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
        <i class="ti ti-trash-x fs-36"></i>
      </span>
      <h4 class="mb-1">Confirm Delete</h4>
      <p class="mb-3">
        You want to delete all the marked items, this cant be undone once you delete.
      </p>
      <div class="d-flex justify-content-center">
        <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
        <a href="javascript:void(0);" class="btn btn-danger" @click="deleteLead">Yes, Delete</a>
      </div>
    </div>
  </div>
</div>
</div>
<!-- /Delete Modal -->

<!-- Bulk Action -->
<div class="modal fade" id="bulk_action_lead">
<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">Bulk Actions</h4>
      <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
        <i class="ti ti-x"></i>
      </button>
    </div>
    <form @submit.prevent="submitBulkAction">
      <div class="modal-body pb-0">
        <div class="row">
        
        <div class="col-md-12">
        <div class="mb-3">  
        <input type="checkbox" class="form-check-input me-2" name="mass_delete" id="mass_delete" v-model="mass_delete" /> 
        <label class="form-label" for="mass_delete">Mass Delete</label>
        </div>
        </div>

        <div class="col-md-12" v-if="!mass_delete">
        <div class="mb-3">
        <label class="form-label">Change Stage </label>
        <vue-select :options="stages" label="name" v-model="lead_stage" />
        </div>
        </div>

        <div class="col-md-12" v-if="!mass_delete">
        <div class="mb-3">
        <label class="form-label">Change Source </label>
        <vue-select :options="sources" label="name" v-model="lead_source" />
        </div>
        </div>

        <div class="col-md-12" v-if="!mass_delete">
        <div class="mb-3">
        <label class="form-label">Assign To </label>
        <vue-select :options="users" label="name" v-model="user" />
        </div>
        </div>

        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
        <button type="submit" class="btn btn-primary">Confirm</button>
      </div>
    </form>
  </div>
</div>
</div>
<!-- /Bulk Action -->

<!-- Leads Conversion -->
<div class="modal fade" id="lead_conversion_modal">
<div class="modal-dialog modal-dialog-centered modal-sm">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">Convert into Customer</h4>
      <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
        <i class="ti ti-x"></i>
      </button>
    </div>
    <form @submit.prevent="convert">
      <div class="modal-body pb-0">
        <div class="row">

        <div class="col-md-12">
        <div class="mb-3">
        <label class="form-label">Company Name <span class="text-danger">*</span></label>
        <input type="text" class="form-control" v-model="company_name" />
        <div v-if="errors.company_name" class="text-danger small mt-1">{{ errors.company_name[0] }}</div>
        </div>
        </div>

        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
        <button type="submit" class="btn btn-primary">Convert</button>
      </div>
    </form>
  </div>
</div>
</div>
<!-- /Leads Conversion -->

  <lead-stage-modal @updated="onStageAdded"></lead-stage-modal>
  <lead-source-modal @updated="onSourceAdded"></lead-source-modal>

</template>